import {BrowserModule} from '@angular/platform-browser';
import {LOCALE_ID, NgModule} from '@angular/core';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {MDBSpinningPreloader, ToastModule} from 'ng-uikit-pro-standard';
import {MainLoginComponent} from './main-login.component/main-login.component';
import {PageNotFoundComponent} from './components/generic/not-found/not-found.component';
import {AppCommonLibsModule} from './common.module/common.module';
import {AuthResource} from './main-login.component/service/auth.resource';
import {NgProgressModule} from 'ngx-progressbar';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {ServiceWorkerModule} from '@angular/service-worker';
import {environment} from '../environments/environment';
import {LoginRepository} from './main-login.component/service/login.repository';
import {LoginService} from './main-login.component/service/login.service';
import {DbBaseRepository} from './common.module/util/db.base.repository';
import {TestComponent} from './TestTemplate/TestTemplate.component';
import {NotificationsModalComponent} from './main-portal.component/notifications-modal.component/notifications-modal.component';
import {MainPortalComponent} from './main-portal.component/main.component';
import {HeaderComponent} from './main-portal.component/header.component';
import {FooterComponent} from './main-portal.component/footer.component';
import {PERFECT_SCROLLBAR_CONFIG, PerfectScrollbarConfigInterface, PerfectScrollbarModule} from 'ngx-perfect-scrollbar';
import {DatosUsuarioComponent} from './main-portal.component/datos-usuario.component/datos-usuario.component';
import {NotificationsResource} from './main-portal.component/service/notifications.resource';
import {UsuarioService} from './main-portal.component/login.component/service/usuario.service';
import {UsuarioResource} from './main-portal.component/login.component/service/usuario.resource';
import {MainAdminComponent} from './main-admin.component/main.component';
import {IndexAdminComponent} from './main-admin.component/index-admin.component';
import {SidebarComponent} from './main-admin.component/sidebar.component';
import {ChatComponent} from './common.module/components/chat-component/chat.component';
import {ChatAdminComponent} from './common.module/components/chat-component/chat-admin.component';
import {ChatRequestResource} from './common.module/components/chat-component/service/chat-request.resource';
import {RecoverAccountComponent} from './main-recover.component/recover-account.component';
import {RegistryComponentComponent} from './main-registry.component/registry-continue.component';
import {LayoutListComponent} from './components/generic/layout-list/layout-list.component';
import {ModalConfirmComponent} from './components/generic/modal-confirm/modal-confirm.component';
import {AccountComponent} from './main-admin.component/account.component/account.component';
import {IndexComponent} from './ruta.directorio.componente/index.component';
import {DynamicFormComponent} from './TestTemplate/formDynamic.component';
import {AvisosCiudadanoComponent} from './main-portal.component/avisos-ciudadano/avisos-ciudadano.component';
import {AvisosCiudadanoResource} from './main-portal.component/service/avisos-ciudadano.resource';
import {AgmCoreModule} from '@agm/core';
import {ChatConfiguracionResource} from './common.module/components/chat-component/service/chat-configuracion.resource';
import {DataSessionShareService} from './common.module/util/data-share-session.service';
import {ConfiguracionGeneralService} from './admin.configuracion-general.module/service/configuracion-general.service';
import {ConfiguracionGeneralResource} from './admin.configuracion-general.module/service/configuracion-general.resource';
import {ConfiguracionTarjetaService} from './admin.configuracion-tarjeta.module/service/configuracion-tarjeta.service';
import {ConfiguracionTarjetaResource} from './admin.configuracion-tarjeta.module/service/configuracion-tarjeta.resource';
import {AuthExtendedResource} from './main-login.component/service/auth-extended.resource';
import {CategoriasResource} from './admin.categorias.module/service/categorias.resource';
import {CategoriasService} from './admin.categorias.module/service/categorias.service';
import {TramitesService} from './admin.tramites.module/service/tramites.service';
import {TramitesResource} from './admin.tramites.module/service/tramites.resource';
import {DocumentosResource} from './admin.tramites.module/service/documentos.resource';
import {DocumentosService} from './admin.tramites.module/service/documentos.service';
import localeEs from '@angular/common/locales/es';
import {registerLocaleData} from '@angular/common';
import {FlujoResource} from './admin.bpm.module/configuracion.flujo.component/service/resource/flujo.resource';
import {FlujoService} from './admin.bpm.module/configuracion.flujo.component/service/flujo.service';
import {DirectivasModule} from './directivas.module/directivas.module';
import {FormalitiesResource} from './main-portal.component/service/formalities.resource';
import { LocationsService } from './admin.index.module/service/locations.service';
import {LocationsResource} from './admin.index.module/service/resource/locations.resource';
import { DashboardComponent } from './admin.dashboard.module/dashboard.component/dashboard.component';

registerLocaleData(localeEs, 'es');

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};


@NgModule({
  declarations: [
    AppComponent,
    MainPortalComponent,
    HeaderComponent,
    FooterComponent,
    MainPortalComponent,
    NotificationsModalComponent,
    MainLoginComponent,
    TestComponent,
    DynamicFormComponent,
    PageNotFoundComponent,
    // LoginCitizenComponent,
    DatosUsuarioComponent,
    MainAdminComponent,
    IndexAdminComponent,
    SidebarComponent,
    ChatComponent,
    ChatAdminComponent,
    RecoverAccountComponent,
    RegistryComponentComponent,
    LayoutListComponent,
    ModalConfirmComponent,
    AccountComponent,
    RecoverAccountComponent,
    IndexComponent,
    AvisosCiudadanoComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    AppCommonLibsModule,
    NgProgressModule,
    ToastModule.forRoot({tapToDismiss: true, timeOut: 8000, toastClass: 'opacity-none'}),
    ServiceWorkerModule.register('ngsw-worker.js', {enabled: environment.production}),
    PerfectScrollbarModule,
    AgmCoreModule.forRoot({
      apiKey: environment.gKey
    }),
    DirectivasModule
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'es' },
    MDBSpinningPreloader,
    BrowserAnimationsModule,
    AuthResource,
    AuthExtendedResource,
    LoginRepository,
    LoginService,
    DbBaseRepository,
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    },
    NotificationsResource,
    UsuarioService,
    UsuarioResource,
    ChatRequestResource,
    ChatConfiguracionResource,
    ConfiguracionGeneralService,
    ConfiguracionGeneralResource,
    ConfiguracionTarjetaService,
    ConfiguracionTarjetaResource,
    AvisosCiudadanoResource,
    DataSessionShareService,
    CategoriasResource,
    CategoriasService,
    TramitesResource,
    TramitesService,
    DocumentosResource,
    DocumentosService,
    FlujoResource,
    FlujoService,
    FormalitiesResource,
    LocationsResource,
    LocationsService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
